import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import apiconfig from "../../config/api-config.js";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import ShowBoxCardChildren from "./TrackTables/ShowBoxComponents/ShowBoxCardChildren";
import ShowBoxBreadcrumbs from "./TrackTables/ShowBoxComponents/ShowBoxBreadcrumbs.js";

const ShowBoxesChild = (props) => {
  const Url = require("url-parse");

  const UrlObj = new Url(window.location.href);

  const sbQuery = UrlObj["query"].split("=");

  let target = sbQuery[1];

  const [collections, setCollections] = useState(null);

  const [statechanged, setStateChanged] = useState(false);

  const categoryTitle = localStorage.getItem("categoryTitle");

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToTop();

    if (!collections) {
      let axiosUrl =
        "https://api.fliktrax.com/newreleases?category=the-precinct&playlist=[]";
      axios({
        baseURL: axiosUrl,
        method: "get",
        auth: {
          username: apiconfig.api.APIUSERNAME,
          password: apiconfig.api.APIPASSWORD,
        },
        headers: {
          "Content-Type": "application/hal+json",
        },
        //timeout: 2000,
      }).then((response) => {
        //console.log(response.data._embedded.newreleases)
        setCollections(response.data._embedded.newreleases);
      });
    }
  }, [collections]);

  return (
    <Container className="ft-container" maxWidth="md">
      <h1 style={{ color: "#000000" }}>
        {target.replace(/the-precinct/g, "").replace(/-/g, " ").toUpperCase()}
      </h1>
      <ShowBoxBreadcrumbs categoryTitle={target} />
      <Box style={{ marginTop: 50 }}>
        <CssBaseline />
        <Grid container spacing={4}>
          {collections &&
            collections
              .filter((item) => item.master_category === target)
              .map((data) => {
                //console.log(data)
                return (
                  <>
                    <Grid item xs={12} sm={6}>
                      {/* <ButtonBase onClick={switchComponant(data)}> */}
                      <ShowBoxCardChildren
                        cardData={data}
                        collections={collections}
                        target={target}
                      />
                      {/* </ButtonBase> */}
                    </Grid>
                  </>
                );
              })}
        </Grid>
      </Box>
      <Box style={{ marginTop: 125 }}></Box>
    </Container>
  );
};

export default ShowBoxesChild;
